<h1>Admin Dashboard</h1>
<div class="section">
  <div class="tile">
    <img class="profits-image" alt="profits graph" src="profits.png">
  </div>
  <div class="tile">
    <div>Active Campaigns</div>
  </div>
</div>

<div class="section">
  <div class="tile">
    <div>Top Agents</div>
  </div>
  <div class="tile">
    <div>Top Creators</div>
  </div>
</div>
